import { render, staticRenderFns } from "./modalFulfillmentKanbanDetail.vue?vue&type=template&id=5f3e709e&scoped=true"
import script from "./modalFulfillmentKanbanDetail.vue?vue&type=script&lang=js"
export * from "./modalFulfillmentKanbanDetail.vue?vue&type=script&lang=js"
import style0 from "./modalFulfillmentKanbanDetail.vue?vue&type=style&index=0&id=5f3e709e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e709e",
  null
  
)

export default component.exports